import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Badge } from '../../components/UI';
import { api } from '../../utils/api';

// "Notes & tools" band — the phase's official Songbook ingredients.
// Prebačeno iz PhaseOverview: deli ga Explore (E), Master (M) i Deliver (D),
// razlikuju se samo podaci koji se učitavaju (filter po phase).

const SectionLabel = ({ children }) => (
  <div style={{ fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-faint)', margin: '4px 0 10px' }}>
    {children}
  </div>
);

export default function PhaseNotes({ phase }) {
  const navigate = useNavigate();
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    api.getSongbook()
      .then(d => setNotes((d.ingredients || []).filter(i => i.phase === phase && i.scope === 'official')))
      .catch(() => setNotes([]));
  }, [phase]);

  return (
    <div style={{ marginTop: 32 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <SectionLabel>Notes &amp; tools</SectionLabel>
        <button
          onClick={() => navigate('/grow/atlas')}
          style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '0.78rem', color: 'var(--ink-soft)', fontFamily: 'var(--font-body)' }}
        >
          Open the Hansen Beck Toolbox →
        </button>
      </div>
      {notes.length === 0 ? (
        <Card style={{ padding: '16px 20px' }}>
          <span style={{ fontSize: '0.88rem', color: 'var(--ink-faint)' }}>Standards for this phase load with the Hansen Beck Toolbox.</span>
        </Card>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 12 }}>
          {notes.map(i => (
            <Card key={i.id} style={{ padding: '14px 16px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 6 }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '0.98rem', color: 'var(--ink)' }}>{i.name}</div>
                <Badge status="default">Standard</Badge>
              </div>
              {i.what && <div style={{ fontSize: '0.83rem', color: 'var(--ink-soft)', marginTop: 4, lineHeight: 1.5 }}>{i.what}</div>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
